module.exports = __webpack_public_path__ + "img/qcells_footer.e84469bf.png";